import { render, staticRenderFns } from "./DataManager.vue?vue&type=template&id=69a86730&scoped=true"
import script from "./DataManager.vue?vue&type=script&lang=js"
export * from "./DataManager.vue?vue&type=script&lang=js"
import style0 from "./DataManager.vue?vue&type=style&index=0&id=69a86730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a86730",
  null
  
)

export default component.exports